<div class="bg-bleuCaliceo-300 bg-opacity-10">
  <section class="layout py-12 lg:py-24 ">

    <h2
      class="font-bold mb-4 text-4xl leading-tight text-bleuCaliceo-300">{{ 'cse' | translate }}</h2>
    <p
      class="font-semibold text-gray-500 text-lg">{{ 'cseDescription' | translate }}
    </p>

    <div class="md:grid grid-cols-2 gap-20 py-12">
      <div class="h-72 w-full relative">
        <img ngSrc="assets/images/cse/interlocuteur.webp" fill="" class="object-cover rounded-lg" alt="">
      </div>

      <div class="py-5 flex justify-center flex-col">
        <h3
          class="font-bold mb-9 text-2xl leading-tight text-bleuCaliceo-300 uppercase">{{ 'preferentialRates' | translate }}</h3>
        <p class="font-medium text-gray-500 text-md"
           [innerHtml]="'preferentialRatesDescription' | translate"></p>
      </div>
    </div>

    <app-cse-contact/>

  </section>
</div>
